import styled from "styled-components";

export const HomeLayout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
  flex-direction: column;
  height: 100vh;
  text-align: center;
`;
